module.exports = __webpack_public_path__ + "img/blue-up-arrow.bad57911.svg";